import React, {
    memo,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import axios from "axios";
import debounce from "lodash/debounce";
import { Box, Button, TextField, Typography } from "@mui/material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { filteruseStyles } from "./FilterOptions";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { storeFiltersValue } from "../../../../redux/actions/TicketsManagement/GetTickets";
import { useDispatch, useSelector } from "react-redux";

interface FilterOption {
    id: number;
    displayName?: string;
    name?: string;
}

interface AsyncFilterMenuProps {
    label: string;
    endpoint: string;
    actionType?: string;
    selectorKey?:string;
}

const AsyncFilterMenu = memo(({ label, endpoint, actionType,selectorKey }: AsyncFilterMenuProps) => {
    const [searchValue, setSearchValue] = useState("");
    const classes = filteruseStyles();
    const dispatch = useDispatch();
    const inputRef = useRef<HTMLInputElement>(null);
    const [options, setOptions] = useState<FilterOption[]>([]);
    const selectedItems = useSelector((state:any) => state?.[`${selectorKey}`]?.OrgList);
    // const [selectedItems, setSelectedItems] = useState<
    //     Record<number, FilterOption>
    // >({});
    const [loading, setLoading] = useState(false);

    const abortControllerRef = useRef<AbortController | null>(null);

    /**
     * Fetch options
     */
    const fetchOptions = useCallback(
        async (search = "") => {
            // Cancel previous API request
            abortControllerRef.current?.abort();

            const controller = new AbortController();
            abortControllerRef.current = controller;

            try {
                setLoading(true);

                const url = search
                    ? `${endpoint}search=${encodeURIComponent(search)}`
                    : endpoint;

                const response = await axios.get(url, {
                    signal: controller.signal,
                } as any);

                const data = Array.isArray(response.data)
                    ? (response.data as FilterOption[])
                    : [];

                // Ignore stale/cancelled requests
                if (!controller.signal.aborted) {
                    setOptions(data);
                }
            } catch (error) {
                if (controller.signal.aborted) {
                    return;
                }

                if (axios.isCancel(error)) {
                    return;
                }

                console.error("Failed to fetch filter options:", error);

                if (!controller.signal.aborted) {
                    setOptions([]);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        },
        [endpoint]
    );

    /**
     * Initial API request
     */
    useEffect(() => {
        fetchOptions();

        return () => {
            abortControllerRef.current?.abort();
        };
    }, [fetchOptions]);

    /**
     * Debounced search
     *
     * Re-created only when fetchOptions changes.
     */
    const debouncedSearch = useMemo(
        () =>
            debounce((value: string) => {
                fetchOptions(value);
            }, 300),
        [fetchOptions]
    );

    /**
     * Cleanup debounce
     */
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    /**
     * Search handler
     */
    const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;

        // Keep the exact input value for UI
        setSearchValue(value);

        const search = value.trim();

        // Cancel pending debounce
        debouncedSearch.cancel();

        // Empty search -> load original options
        if (!search) {
            fetchOptions();
            return;
        }

        // Don't search for a single character
        if (search.length < 2) {
            return;
        }

        debouncedSearch(search);
    },
    [debouncedSearch, fetchOptions]
);

    
    const toggleSelection = useCallback((option: FilterOption) => {
        const next = { ...selectedItems };

        if (next[option.id]) {
            delete next[option.id];
        } else {
            next[option.id] = option;
        }

        dispatch(storeFiltersValue(next, `TCKT_ORG_VALUE${actionType??""}`));
        return next;
    }, [selectedItems]);

    const clearSelectedItems = useCallback(() => {
        dispatch(storeFiltersValue({}, `TCKT_ORG_VALUE${actionType??""}`));
    }, [dispatch]);
    return (
        <Box>
        <Typography className={classes.filterTitle} sx={{ p: 1 }}>Choose Organisation</Typography>

            

            <Box sx={{ p: 1 }}>
                <TextField
                    fullWidth
                    size="small"
                    type="search"
                    autoComplete="off"
                    ref={inputRef}
                    placeholder={`Search ${label}`}
                    onChange={handleSearch}
                    className="common-new-input"
                />
                {Object.keys(selectedItems).length > 0 &&
                    <Box className="row m-0 justify-content-end async-filter-input-actions">
                        <Typography>{Object.keys(selectedItems).length} Items Selected</Typography>
                        <Button variant="text" onClick={clearSelectedItems}>
                            <CancelOutlinedIcon /> Clear All
                        </Button>
                    </Box>
                }
                {/* {
                    searchValue === "" && Object.keys(selectedItems).length > 0 && (
                        <>
                            {Object.keys(selectedItems).map((key: string) => {
                                const option = selectedItems[parseInt(key)];
                                if (!option) return null;
                                    return (

                                         <Typography key={option?.id} onClick={() => toggleSelection(option)} className={classes.filterItem}>
                                            <CheckBoxIcon className={`${classes.checkedIcon} checkbox-icon`}/> 
                                            <span>{option.displayName ?? option.name}</span>
                                        </Typography>
                                        // <Typography
                                        //     key={option.id}
                                        //     className={`filter-item checked`}
                                        //     onClick={() => toggleSelection(option)}
                                        // >
                                        //     {option.displayName ?? option.name}
                                        // </Typography>
                                    );
                            })}
                        </>
                    )
                } */}


                {loading ? (
                    <Typography className="filter-item">
                        Loading...
                    </Typography>
                ) : options.length > 0 ? (
                    options.map((option) => {
                        const selected = selectedItems[option.id];

                        return (
                            //  searchValue !== "" || !selected ? (

                                <Typography key={option?.id} onClick={() => toggleSelection(option)} className={classes.filterItem}>
                            {selected ? <CheckBoxIcon className={`${classes.checkedIcon} checkbox-icon`}/> : <CheckBoxOutlineBlankIcon />} 
                            <span>{option.displayName ?? option.name}</span>
                        </Typography>
   
                        // ) : null
                            
                        );
                    })
                ) : (
                    <Typography className="filter-item">
                        No {label} found
                    </Typography>
                )}
            </Box>
        </Box>
    );
});

AsyncFilterMenu.displayName = "AsyncFilterMenu";

export default AsyncFilterMenu;